import React from "react";
import { Youtube, Instagram, Music2, Twitter, Facebook, Globe } from "lucide-react";

/**
 * PlatformIcon — small icon for a given platform key.
 * Use across submit dropdowns, View Campaign modal allowed-platforms, etc.
 */
export function PlatformIcon({ platform, size = 14, className = "" }) {
  const p = String(platform || "").toLowerCase();
  if (p === "youtube") return <Youtube size={size} className={`text-rose-500 ${className}`} />;
  if (p === "instagram") return <Instagram size={size} className={`text-fuchsia-400 ${className}`} />;
  if (p === "tiktok") return <Music2 size={size} className={`text-zinc-200 ${className}`} />;
  if (p === "twitter" || p === "x") return <Twitter size={size} className={`text-sky-400 ${className}`} />;
  if (p === "facebook") return <Facebook size={size} className={`text-blue-500 ${className}`} />;
  return <Globe size={size} className={`text-zinc-400 ${className}`} />;
}

export function PlatformPill({ platform, size = 12, className = "" }) {
  const label = String(platform || "").charAt(0).toUpperCase() + String(platform || "").slice(1);
  return (
    <span data-testid={`platform-pill-${platform}`} className={`inline-flex items-center gap-1.5 rounded-full border border-border/60 bg-background/60 px-2 py-1 text-[11px] font-medium text-zinc-200 ${className}`}>
      <PlatformIcon platform={platform} size={size} /> {label}
    </span>
  );
}
